import React from "react";
import Image from "next/image";

interface LogoProps {
  className?: string;
  iconOnly?: boolean;
  inverse?: boolean; // If true, uses white text for dark backgrounds
}

export default function Logo({ className = "", iconOnly = false, inverse = false }: LogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Brand Logo Image */}
      <div 
        className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl p-1 shadow-sm transition-all duration-300 ${
          inverse
            ? "bg-white/10 border border-white/20"
            : "bg-white dark:bg-surface-container border border-outline-variant/20 dark:border-outline-variant/40"
        }`}
      >
        <Image
          src="/logo.svg"
          alt="Beyond Ambition Logo"
          width={34}
          height={34}
          className="w-full h-full object-contain"
          priority
          fetchPriority="high"
        />
      </div>

      {/* Brand Text */}
      {!iconOnly && (
        <div className="flex flex-col leading-none text-left">
          <span 
            className={`font-display text-[15px] font-extrabold tracking-wider transition-colors ${
              inverse ? "text-white" : "text-[#3C3530] dark:text-[#F2EAE4]"
            }`}
          >
            BEYOND
          </span>
          <span 
            className={`font-display text-[15px] font-extrabold tracking-wider transition-colors ${
              inverse ? "text-white" : "text-[#3C3530] dark:text-[#F2EAE4]"
            }`}
          >
            AMBITION
          </span>
          <span 
            className={`font-display text-[9px] font-semibold tracking-[0.22em] mt-[2px] transition-colors ${
              inverse ? "text-primary-fixed-dim" : "text-primary dark:text-[#FFB586]"
            }`}
          >
            LIMITED
          </span>
        </div>
      )}
    </div>
  );
}
